import GeneralModel from './GeneralModel';
import mainAPI from "../api/MainAPI";

export default class UserGroupModel extends GeneralModel {
	constructor(socket) {
		super('user_group', socket, async ()  => await mainAPI.user_group.current());
	}

	obj = () => {
		for (let i in this.Objects) {
			return this.Objects[i];
		}
		return null;
	};
}



// WEBPACK FOOTER //
// ./src/model/UserGroupModel.js